const actionItemInitialColumn = [
  {
    title: 'Workstream Action Number',
    dataIndex: 'actionItemNumber',
    key: 'actionItemNumber',
  },
  {
    title: 'Workstream Action Description',
    dataIndex: 'workstreamActionName',
    key: 'workstreamActionName',
  },
  {
    title: 'Owner',
    dataIndex: 'owner',
    key: 'owner',
  },
  {
    title: 'Collaborator',
    dataIndex: 'collaborator',
    key: 'collaborator',
  },
  {
    title: 'Subworkstream',
    dataIndex: ['owner', 'subworkstream', 'subworkstreamName'],
    key: 'subworkstream',
  },
  {
    title: 'Workstream',
    dataIndex: ['owner', 'subworkstream', 'workstream', 'workstreamName'],
    key: 'workstream',
  },
  {
    title: 'Selected for To Meeting',
    dataIndex: 'selectedForToMeeting',
    key: 'selectedForToMeeting',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Source',
    dataIndex: 'source',
    key: 'source'
  },
  {
    title: 'Planning Summary',
    dataIndex: 'planningSummary',
    key: 'planningSummary',
  },
  {
    title: 'Comment',
    dataIndex: 'comment',
    key: 'comment',
  },
  {
    title: 'Due Date',
    dataIndex: 'dueDate',
    key: 'dueDate',
  },
  {
    title: 'Created on',
    dataIndex: 'Created on',
    key: 'Created on',
  },
  {
    title: 'Updated on',
    dataIndex: 'Updated on',
    key: 'Updated on',
  },
  {
    title: 'Created by',
    dataIndex: 'createdBy',
    key: 'createdBy',
  },
  {
    title: 'Updated by',
    dataIndex: 'updatedBy',
    key: 'updatedBy',
  },
];
export default actionItemInitialColumn;
